import { JSON_CONTENT_TYPE, TOKEN_NAME } from '../../constant/constants';
import { ModuleDto } from '../../dto/user/ModuleDto';
import { IApiParams } from '../../interface/IApiParams';
import { getApi } from '../getApi';

export const apiDeleteModule = async (dto: ModuleDto) => {
  const params: IApiParams = {
    url: '/license/deleteModules.php',
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      Token: localStorage.getItem(TOKEN_NAME),
    },
  };
  return getApi(params, 'DELETE', dto);
};
